import {LoginHelper} from "../../apps/root/assets/js/login-helper";

export let Login = (() => {

	let helper = new LoginHelper();
	helper.triggersSelector = '[data-action="login"]';
	helper.modalSelector = 'loginModal';
	helper.usernameFieldSelector = 'input[name="bonusblitzlogin"]';
	helper.passwordFieldSelector = 'input[name="bonusblitzpassword"]';
	helper.rememberMeCheckSelector = 'input[name="bonusblitzremember"]';
	helper.logoutSelector = '[data-btn="logout"]';
	helper.loaderSelector = '#loginModal .BoxContPopup';
	helper.loginResponseSelector = '.login--response';
	helper.colorStyles = {bad: 'red', success: 'green', default: 'blue', hide: 'white'};
	helper.reloadPages = ['cashier', 'fun-mode'];
	helper.pagename = location.pathname.split("/").pop();

	const getTriggers = () => {
		return helper.getTriggers()
	}

	const setAuthStatus = async () => {
		await helper.setAuthStatus();
	}

	const checkIfLoggedIn = () => {
		return helper.checkIfLoggedIn();
	}

	const triggerControl = (e, btn) => {
		return helper.triggerControl(e, btn);
	}

	const toggleModal = async (e, goto) => {
		await helper.toggleModal(e, goto);
	}

	const requireAuthOn = (elements = null) => helper.requireAuthOn(elements);

	return {
		getTriggers, toggleModal, triggerControl, checkIfLoggedIn, setAuthStatus, requireAuthOn
	}
})();
